import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { QueryApiService } from 'src/app/shared/services/customer-api/query-api.service';

/**
 * redirect to specific query if no one is selected and store the data in the auth service
 */
export const queryGuard: CanActivateFn = (_route, state) => {
  const queryApi = inject(QueryApiService);
  const router = inject(Router);

  return forkJoin({
    groups: queryApi.getGroupsQuery(),
    queries: queryApi.getQuery(),
  }).pipe(
    map((result) => {
      queryApi.querys = result.groups;
      queryApi.iquery = undefined;
      queryApi.query = undefined;
      if (result.groups[0]) {
        if (!state.root.queryParams.id) {
          const sortedGroups = JSON.parse(JSON.stringify(result.groups));
          sortedGroups.sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
          router.navigate([state.url.split('?')[0]], {
            queryParams: {
              id: sortedGroups[0].uid,
              groupId: sortedGroups[0].uid,
              news: state.root.queryParams.news,
              highlight: state.root.queryParams.highlight,
              time: state.root.queryParams.time,
              filter: state.root.queryParams.filter,
              lang: state.root.queryParams.lang
                ? state.root.queryParams.lang
                : 'en,de',
              feed: state.root.queryParams.feed
                ? state.root.queryParams.feed
                : 'non_professional,online,print,professional',
              ranks: state.root.queryParams.ranks,
              // categories: state.root.queryParams.categories ? state.root.queryParams.categories : 'gent,gedu,ciprof,glife,cmarkr,gpersf,gsci,gspo,gwea',
              categories: state.root.queryParams.categories
                ? state.root.queryParams.categories
                : '',
              continents: state.root.queryParams.continents,
              countries: state.root.queryParams.countries,
              factuality: state.root.queryParams.factuality,
              temporality: state.root.queryParams.temporality,
              event_ids: state.root.queryParams.event_ids,
              sort: 'ratio',
              nomenu: state.root.queryParams.nomenu,
              notitle: state.root.queryParams.notitle,
            },
            // replaceUrl: true,
          });
        } else {
          if (state.root.queryParams.id === 'default') {
            queryApi.iquery = result.queries;
            queryApi.query = {
              uid: 'default',
              name: 'default',
              query: {
                operator: 'or',
                filters: [],
                groups: queryApi.iquery.map((query) => query.query),
              },
            };
            return true;
          } else {
            let collectionIdExists = false;
            let queryIdExists = false;
            result.groups.map((group) => {
              if (group.uid === state.root.queryParams.id) {
                queryApi.iquery = group.content;
                queryApi.query = {
                  uid: group.uid,
                  name: group.name,
                  query: {
                    operator: 'or',
                    filters: [],
                    groups: group.content.map((query) => query.query),
                  },
                };
              } else {
                group.content.map((query) => {
                  if (query.uid === state.root.queryParams.id) {
                    queryApi.query = query;
                  }
                });
              }
              if (group.uid === state.root.queryParams.groupId) {
                collectionIdExists = true;
              }
            });
            if (queryApi.query === undefined) {
              result.queries.map((query) => {
                if (query.uid === state.root.queryParams.id) {
                  queryApi.query = query;
                  queryIdExists = true;
                }
              });
            } else {
              queryIdExists = true;
            }
            if (
              (!queryIdExists || !collectionIdExists) &&
              state.root.queryParams.groupId !== 'default'
            ) {
              const sortedGroups = JSON.parse(JSON.stringify(result.groups));
              sortedGroups.sort((a, b) => {
                return a.name.localeCompare(b.name);
              });
              router.navigate([state.url.split('?')[0]], {
                queryParams: {
                  id: sortedGroups[0].uid,
                  groupId: sortedGroups[0].uid,
                  news: state.root.queryParams.news,
                  highlight: state.root.queryParams.highlight,
                  time: state.root.queryParams.time,
                  filter: state.root.queryParams.filter,
                  lang: state.root.queryParams.lang
                    ? state.root.queryParams.lang
                    : 'en,de',
                  feed: state.root.queryParams.feed
                    ? state.root.queryParams.feed
                    : 'non_professional,online,print,professional',
                  ranks: state.root.queryParams.ranks,
                  // categories: state.root.queryParams.categories ? state.root.queryParams.categories : 'gent,gedu,ciprof,glife,cmarkr,gpersf,gsci,gspo,gwea',
                  categories: state.root.queryParams.categories
                    ? state.root.queryParams.categories
                    : '',
                  continents: state.root.queryParams.continents,
                  countries: state.root.queryParams.countries,
                  factuality: state.root.queryParams.factuality,
                  temporality: state.root.queryParams.temporality,
                  event_ids: state.root.queryParams.event_ids,
                  sort: 'ratio',
                  nomenu: state.root.queryParams.nomenu,
                  notitle: state.root.queryParams.notitle,
                },
                // replaceUrl: true,
              });
            }
            return true;
          }
        }
      } else {
        if (state.root.queryParams.id === 'default') {
          queryApi.iquery = result.queries;
          queryApi.query = {
            uid: 'default',
            name: 'default',
            query: {
              operator: 'or',
              filters: [],
              groups: queryApi.iquery.map((query) => query.query),
            },
          };
          return true;
        } else if (state.root.queryParams.groupId === 'default') {
          if (state.root.queryParams.id) {
            result.queries.map((query) => {
              if (query.uid === state.root.queryParams.id) {
                queryApi.query = query;
              }
            });
            return true;
          } else {
            router.navigate([state.url.split('?')[0]], {
              queryParams: {
                id: 'default',
                groupId: 'default',
                news: state.root.queryParams.news,
                highlight: state.root.queryParams.highlight,
                time: state.root.queryParams.time,
                lang: state.root.queryParams.lang
                  ? state.root.queryParams.lang
                  : 'en,de',
                feed: state.root.queryParams.feed
                  ? state.root.queryParams.feed
                  : 'non_professional,online,print,professional',
                ranks: state.root.queryParams.ranks,
                panels: state.root.queryParams.panels,
                // categories: state.root.queryParams.categories ? state.root.queryParams.categories : 'gent,gedu,ciprof,glife,cmarkr,gpersf,gsci,gspo,gwea',
                categories: state.root.queryParams.categories
                  ? state.root.queryParams.categories
                  : '',
                continents: state.root.queryParams.continents,
                countries: state.root.queryParams.countries,
                factuality: state.root.queryParams.factuality,
                temporality: state.root.queryParams.temporality,
                event_ids: state.root.queryParams.event_ids,
                sort: 'ratio',
                nomenu: state.root.queryParams.nomenu,
                notitle: state.root.queryParams.notitle,
              },
              // replaceUrl: true,
            });
          }
        } else {
          router.navigate([state.url.split('?')[0]], {
            queryParams: {
              id: 'default',
              groupId: 'default',
              news: state.root.queryParams.news,
              highlight: state.root.queryParams.highlight,
              time: state.root.queryParams.time,
              lang: state.root.queryParams.lang
                ? state.root.queryParams.lang
                : 'en,de',
              feed: state.root.queryParams.feed
                ? state.root.queryParams.feed
                : 'non_professional,online,print,professional',
              ranks: state.root.queryParams.ranks,
              panels: state.root.queryParams.panels,
              // categories: state.root.queryParams.categories ? state.root.queryParams.categories : 'gent,gedu,ciprof,glife,cmarkr,gpersf,gsci,gspo,gwea',
              categories: state.root.queryParams.categories
                ? state.root.queryParams.categories
                : '',
              continents: state.root.queryParams.continents,
              countries: state.root.queryParams.countries,
              factuality: state.root.queryParams.factuality,
              temporality: state.root.queryParams.temporality,
              event_ids: state.root.queryParams.event_ids,
              sort: 'ratio',
              nomenu: state.root.queryParams.nomenu,
              notitle: state.root.queryParams.notitle,
            },
            // replaceUrl: true,
          });
        }
      }
    }),
  );
};
